<template>
  <a-modal
    title="推广小程序"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk">

    <!-- a-spin加载中 -->
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="小程序id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="" :rows="4" v-decorator="['app_id',{initialValue:dataObj.app_id}]" />
        </a-form-item>

        <a-form-item
          label="选择推送机器人"
          style="width: 900px;"
          :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
          :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
          <!-- 组件 -->
          <robot-multiple1 @sendRobotList="robotList"
            v-decorator="['robotids', { rules: [{ required: true, message: '必填项' }] }]"></robot-multiple1>
        </a-form-item>

      </a-form>
    </a-spin>

  </a-modal>
</template>

<script>
// 选择机器人
import RobotMultiple1 from './RobotMultiple'

// api接口
import CompanyApi from '@/api/company'

export default {
  data(){
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false, // 	对话框是否可见
      confirmLoading: false, // 确定按钮
      form: this.$form.createForm(this),
      dataObj: {}, // 这一行数据
      robotListArr: [], // 子组件传过来的机器人列表的数据
      robotNameArr: [], // 不在线的机器人的名称
    }
  },
  components: {
    RobotMultiple1,
  },
  methods: {
    // 展示对话框
    show (data) {
      this.dataObj = data
      // console.log('============',this.dataObj);
      this.visible = true
    },
    // 隐藏对话框
    handleCancel () {
      this.visible = false
      // 清空表单数据
      this.form.resetFields()
    },
    // 推广小程序
    handleOk(){
      // console.log('点击确定按钮了');
      this.form.validateFields((err, values) => {
        // console.log('err===',err)
        // console.log('values==',values);
        if(values.robotids.length>0){
          let robotids = values.robotids.join(',')
          CompanyApi.pushMinApp({
            min_program_id: values.app_id, // 小程序id
            sub_id: robotids
          }).then((res)=>{
            if(res.code==1){
              this.visible = false
              this.$message.success('推送成功');
              // 清空表单数据
              this.form.resetFields()
            }else{
              this.visible = false
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    // 子组件传递过来的每个机器人的具体数据
    robotList(list){
      this.robotListArr = list
      // console.log('我看看机器人列表的数据=',this.robotListArr);
    },
  }
}
</script>

<style>

</style>